export const enlacesRoutes = (apiBase) => ({
  getEnlaceTypes: `${apiBase}/enlaces/types`,
  getEnlaces: (keyword = "", subtipos = "", page = 1, limit = 20) =>
    `${apiBase}/enlaces?keyword=${encodeURIComponent(keyword)}&subtipos=${subtipos}&page=${page}&limit=${limit}`,
  createEnlace: `${apiBase}/enlaces`,
});

